<div class="filter-element">
  <div ngbDropdown #dropdownWebGL="ngbDropdown">
    <button class="btn btn-outline-primary" id="dropdownWebGL" ngbDropdownAnchor (focus)="dropdownWebGL.open()">
      {{ 'Functions' | translate }}
    </button>

    <div ngbDropdownMenu aria-labelledby="dropdownWebGL">
      <button ngbDropdownItem>
        <span class="fa-solid fa-pen"></span>
        <span translate>Edit page</span>
      </button>
      <button ngbDropdownItem (click)="onOpenWebGLSettingsModal()">
        <span class="fa-solid fa-cube"></span>
        <span translate>WebGL settings</span>
      </button>
      <button ngbDropdownItem>
        <span class="fa-solid fa-clone"></span>
        <span translate>Duplicate</span>
      </button>
      <button ngbDropdownItem class="text-danger">
        <span class="fa-solid fa-trash"></span>
        <span translate>Delete</span>
      </button>
    </div>
  </div>
</div>